import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from "./components/Navbar";
import Home from "./components/home/home";
import Footer from './components/Footer';
import Plans from './components/Planning/Plans';
import Testimonial from './components/Testimonial/Testimonials';
import PrivacyPolicy from './components/Privacy/PrivacyPolicy';
import ScrollToTop from './components/utils/SccrollToTop';
import TermsAndConditions from './components/TermsAndConditions/TermsAndConditions';
import RefundPolicy from './components/refund/refundpolicy';
import TxtReader from './components/txtfile/textfile';
import Brand from './components/Brand/brand';

function App() {
  return (

    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Plans" element={<Plans />} />
        <Route path="/Testimonials" element={<Testimonial />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
        <Route path="/RefundPolicy" element={<RefundPolicy />} />
        <Route path="/app-ads.txt" element={<TxtReader />} />
        <Route path="/business/Startup" element={<Brand />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
